<div class="screens-section">
  <div class="screens-heading-wrapper">
    <span class="screens-star" aria-hidden="true">&#9733;</span>
    <h2 class="screens-heading">See the <span class="screens-heading--highlight">screens</span></h2>
    <p class="screens-desc">A closer look at the POS in action — from an active sale to checkout.</p>
  </div>

  <div class="screens-shell">
    <div class="screens-tabs">
      <button
        type="button"
        class="screens-tab"
        *ngFor="let screen of screens; let i = index"
        [class.screens-tab--active]="i === activeIndex"
        (click)="select(i)"
      >
        <span class="screens-tab-number">{{ screen.number }}</span>
        <span class="screens-tab-label">{{ screen.label }}</span>
      </button>
    </div>

    <div class="screens-preview">
      <img [src]="screens[activeIndex].image" [alt]="screens[activeIndex].label" />
    </div>
  </div>
</div>
